import { Skeleton } from "antd"

const ButtonSubmitSearchFlightsSkeleton = () => {

  return (
    <Skeleton.Button
      active
      block
      size='large'
      style={{
        minWidth: '20rem'
      }}
    />
  )
}

export default ButtonSubmitSearchFlightsSkeleton